import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import save from './save';
import icon from './icon';

registerBlockType( metadata.name, {
	edit: Edit,
	save,
	icon,
} );
